import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getPositions, placeSquareOff, getMyOrders, getHoldings, getDayPositions, getBFPositions } from '../services/api';

/* ─── Navia logo (embedded base64 — always works) ───────────────────────────*/
const NAVIA_LOGO = 'data:image/png;base64,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';

/* ─── Google Font ────────────────────────────────────────────────────────────*/
const _fl = document.createElement('link');
_fl.rel = 'stylesheet';
_fl.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&family=DM+Mono:wght@400;500&display=swap';
if (!document.head.querySelector('[href*="DM+Sans"]')) document.head.appendChild(_fl);

/* ─── Helpers ────────────────────────────────────────────────────────────────*/
// All API calls use axios instances from ../services/api.js
// Auth (Bearer token) is attached automatically via axios interceptors
async function placeHoldingsSquareOff(payload) {
  // Holdings square-off uses same squareoff endpoint as F&O
  const res = await placeSquareOff(payload);
  return res.data;
}
function formatExpiry(d) {
  if (!d) return '—';
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
}
function formatStrike(v) { if (!v && v !== 0) return null; return Number(v).toLocaleString('en-IN'); }
function fmtQty(v) { if (v===null||v===undefined) return '0'; const n=Number(v); return Number.isInteger(n)?n.toString():n.toFixed(2); }
function getInitials(name) { if (!name) return 'C'; return name.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase(); }
function useIsMobile() {
  const [m, setM] = useState(window.innerWidth < 768);
  useEffect(() => { const h=()=>setM(window.innerWidth<768); window.addEventListener('resize',h); return ()=>window.removeEventListener('resize',h); }, []);
  return m;
}
function injectCSS(id, css) {
  let el = document.getElementById(id);
  if (!el) { el=document.createElement('style'); el.id=id; document.head.appendChild(el); }
  el.textContent = css;
}

/* ─── Theme system ────────────────────────────────────────────────────────────*/
const THEMES = {
  light: {
    bg:'#F4F6F9', surf:'#FFFFFF', surf2:'#F0F2F5', bdr:'rgba(0,0,0,0.08)', bdr2:'rgba(0,0,0,0.14)',
    tx:'#0D0F12', tx2:'#5A6272', tx3:'#9BA3B0',
    brand:'#1B4FD8', brandL:'#EEF2FF', brandD:'#0C447C', brandH:'#1338A8',
    ok:'#1D9E75', okBg:'#E1F5EE', okTx:'#085041',
    err:'#DC2626', errBg:'#FEF2F2', errTx:'#991B1B',
    warn:'#D97706', warnBg:'#FFFBEB', warnTx:'#92400E',
    buy:'#1B5E20', sell:'#B71C1C', flat:'#6B7280',
    cePill:{ bg:'#E8F5E9', tx:'#1B5E20', bdr:'#A5D6A7' },
    pePill:{ bg:'#FFEBEE', tx:'#B71C1C', bdr:'#FFCDD2' },
    futPill:{ bg:'#E3F2FD', tx:'#0D47A1', bdr:'#90CAF9' },
  },
  dark: {
    bg:'#0B0F1A', surf:'#141928', surf2:'#1C2236', bdr:'rgba(255,255,255,0.08)', bdr2:'rgba(255,255,255,0.15)',
    tx:'#F0F4FF', tx2:'#8B95B0', tx3:'#4B5470',
    brand:'#4F7EF7', brandL:'#1A2460', brandD:'#93B4FF', brandH:'#3B6AE8',
    ok:'#34D399', okBg:'#052E1C', okTx:'#6EE7B7',
    err:'#F87171', errBg:'#2D1010', errTx:'#FCA5A5',
    warn:'#FBBF24', warnBg:'#2D1F00', warnTx:'#FDE68A',
    buy:'#4ADE80', sell:'#F87171', flat:'#6B7280',
    cePill:{ bg:'#052E1C', tx:'#6EE7B7', bdr:'#065F46' },
    pePill:{ bg:'#2D1010', tx:'#FCA5A5', bdr:'#7F1D1D' },
    futPill:{ bg:'#0C1A3A', tx:'#93B4FF', bdr:'#1E3A8A' },
  },
  hc: {
    bg:'#000', surf:'#0A0A0A', surf2:'#111', bdr:'rgba(255,255,255,0.3)', bdr2:'rgba(255,255,255,0.6)',
    tx:'#FFF', tx2:'#CCC', tx3:'#999',
    brand:'#4D9EFF', brandL:'#001A3D', brandD:'#7DBFFF', brandH:'#2277EE',
    ok:'#00FF88', okBg:'#003319', okTx:'#00FF88',
    err:'#FF4444', errBg:'#330000', errTx:'#FF8888',
    warn:'#FFD700', warnBg:'#332700', warnTx:'#FFD700',
    buy:'#00FF88', sell:'#FF4444', flat:'#AAAAAA',
    cePill:{ bg:'#003319', tx:'#00FF88', bdr:'#00AA55' },
    pePill:{ bg:'#330000', tx:'#FF8888', bdr:'#AA0000' },
    futPill:{ bg:'#001A3D', tx:'#7DBFFF', bdr:'#2277EE' },
  }
};

/* ═══════════════════════════════════════════════════════════════════════════*/
export default function Dashboard({ client, onLogout }) {
  /* ── Data state ──────────────────────────────────────────────────────────*/
  const [positions,       setPositions]       = useState([]);
  const [orders,          setOrders]          = useState([]);
  const [bfData,          setBfData]          = useState(null);
  const [dayData,         setDayData]         = useState(null);
  const [holdingsData,    setHoldingsData]    = useState(null);
  const [loading,         setLoading]         = useState(true);
  const [bfLoading,       setBfLoading]       = useState(false);  // don't block on BF
  const [dayLoading,      setDayLoading]      = useState(false);  // don't block on Day
  const [holdingsLoading, setHoldingsLoading] = useState(true);
  const [activeTab,       setActiveTab]       = useState('positions');
  const [confirmModal,    setConfirmModal]    = useState(null);
  const [placing,         setPlacing]         = useState(false);
  const [message,         setMessage]         = useState('');
  const [messageType,     setMessageType]     = useState('success');
  const [placedHoldings,  setPlacedHoldings]  = useState({});
  const [placedDayEquity, setPlacedDayEquity] = useState({});
  const [placedFO,        setPlacedFO]        = useState({});  // tracks F&O sq-off placed locally
  const [ssoBlockModal,   setSsoBlockModal]   = useState(false);
  const [showProfile,     setShowProfile]     = useState(false);
  const [showA11y,        setShowA11y]        = useState(false);
  const [showHelp,        setShowHelp]        = useState(false);
  const [profileData,     setProfileData]     = useState(null);  // fetched from /api/auth/profile

  /* ── Accessibility state ─────────────────────────────────────────────────*/
  const [themeKey,      setThemeKey]      = useState(() => localStorage.getItem('nb_theme') || 'light');
  const [fontSize,      setFontSize]      = useState(() => parseInt(localStorage.getItem('nb_fs') || '14'));
  const [reduceMotion,  setReduceMotion]  = useState(() => localStorage.getItem('nb_rm') === '1');
  const [largeTT,       setLargeTT]       = useState(() => localStorage.getItem('nb_ltt') === '1');
  const [focusRing,     setFocusRing]     = useState(() => localStorage.getItem('nb_fr') !== '0');

  const T = THEMES[themeKey];
  const isMobile = useIsMobile();
  const fs = fontSize;

  /* ── Fetch full profile from backend on mount ───────────────────────────*/
  useEffect(() => {
    import('../services/api').then(({ default: axiosApi }) => {
      axiosApi.get('/auth/profile')
        .then(res => { if (res.data?.client) setProfileData(res.data.client); })
        .catch(() => {}); // silent — uses client prop as fallback
    });
  }, []);

  useEffect(() => { localStorage.setItem('nb_theme', themeKey); }, [themeKey]);
  useEffect(() => { localStorage.setItem('nb_fs',    fontSize);  }, [fontSize]);
  useEffect(() => { localStorage.setItem('nb_rm',    reduceMotion?'1':'0'); }, [reduceMotion]);
  useEffect(() => { localStorage.setItem('nb_ltt',   largeTT?'1':'0'); }, [largeTT]);
  useEffect(() => { localStorage.setItem('nb_fr',    focusRing?'1':'0'); }, [focusRing]);

  useEffect(() => {
    const trans = reduceMotion ? 'none' : 'all 0.18s ease';
    const focus = focusRing ? `*:focus-visible{outline:3px solid ${T.brand};outline-offset:2px}` : `*:focus-visible{outline:none}`;
    const btnH  = largeTT ? '48px' : '40px';
    injectCSS('nb-dash-css', `
      *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
      body{font-family:'DM Sans',-apple-system,sans-serif}
      .nb-btn{min-height:${btnH};transition:${trans}}
      ${focus}
      .nb-card-hov:hover{border-color:${T.brand}!important}
      .nb-slide-up{animation:nbSU ${reduceMotion?'0s':'0.2s'} ease}
      @keyframes nbSU{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}
      .nb-fade{animation:nbFd ${reduceMotion?'0s':'0.15s'} ease}
      @keyframes nbFd{from{opacity:0}to{opacity:1}}
      ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:${T.bdr2};border-radius:99px}
    `);
  }, [T, reduceMotion, focusRing, largeTT]);

  /* ── Data loaders ────────────────────────────────────────────────────────*/
  const firstLoadRef = useRef(true); // track initial load vs background refresh
  const loadData = useCallback(async () => {
    try {
      const [p,o] = await Promise.all([getPositions(), getMyOrders()]);
      const fetchedPositions = p.data.positions || [];
      const fetchedOrders    = o.data.orders    || [];
      setPositions(fetchedPositions);
      setOrders(fetchedOrders);

      // Re-build placedFO from existing orders so button stays disabled after refresh
      // Net positions (day_positions) have no squareoff_placed flag of their own —
      // placedFO is rebuilt entirely from order history (source of truth for button state)
      const foPlaced = {};
      fetchedOrders.forEach(ord => {
        // Only mark as placed for ACTIVE orders (not traded, not admin-only FILE_GENERATED)
        const activeStatuses = ['ORDER_RECEIVED','RECEIVED','PARTIALLY_TRADED'];
        if (activeStatuses.includes((ord.status||'').toUpperCase())) {
          // Include strike/expiry/option_type so a different contract on the same
          // underlying symbol (e.g. a different NIFTY strike) is never incorrectly
          // treated as already having an order placed.
          const k = `${ord.symbol}|${ord.exchange}|${ord.segment||'FO'}|${ord.expiry_date||''}|${ord.strike_price||''}|${ord.option_type||''}`;
          foPlaced[k] = true;
        }
      });
      setPlacedFO(prev => ({ ...prev, ...foPlaced }));
    } catch(e) { console.error(e); }
    setLoading(false);
  },[]);
  const loadBF = useCallback(async () => {
    // Only show spinner on first load — silent refresh afterwards (no blinking)
    if(firstLoadRef.current) setBfLoading(true);
    try {
      const r    = await getBFPositions();
      const raw  = r.data;                          // axios wraps in .data

      // Normalise response — always re-split from the full positions array
      // Backend returns: { success, options:[], futures:[], positions:[ALL] }
      // We always use positions[] to re-split so nothing is missed
      let options = [], futures = [];
      let allPositions = [];

      if (Array.isArray(raw)) {
        allPositions = raw;
      } else if (raw?.positions && Array.isArray(raw.positions)) {
        // Use the full positions array — most reliable source
        allPositions = raw.positions;
      } else if (raw?.data && Array.isArray(raw.data)) {
        allPositions = raw.data;
      } else if (raw?.data?.positions) {
        allPositions = raw.data.positions;
      }

      // Split from full array by instrument_type (case-insensitive)
      if (allPositions.length > 0) {
        options = allPositions.filter(p => (p.instrument_type||'').toUpperCase() === 'OPTIONS');
        futures = allPositions.filter(p => (p.instrument_type||'').toUpperCase() === 'FUTURES');
      } else {
        // Fallback: use pre-split arrays from backend if positions key missing
        options = (raw?.options || []).filter(p => (p.instrument_type||'').toUpperCase() === 'OPTIONS');
        futures = (raw?.futures || []).filter(p => (p.instrument_type||'').toUpperCase() === 'FUTURES');
      }

      // Filter out zero-qty records
      const isNonZero = p => {
        const qty = Number(p.qty_in_lots ?? p.total_open_qty ?? p.opng_lng_qty ?? 0);
        const shrt = Number(p.opng_shrt_qty ?? 0);
        return qty !== 0 || shrt !== 0;
      };
      options = options.filter(isNonZero);
      futures = futures.filter(isNonZero);

      setBfData({
        options,
        futures,
        total_positions: options.length + futures.length,
        total_open_qty:  [...options, ...futures].reduce((s, p) =>
          s + Math.abs(Number(p.qty_in_lots ?? p.total_open_qty ?? p.opng_lng_qty ?? 0)), 0)
      });
    } catch(e) {
      console.error('BF load error:', e);
      setBfData({ options:[], futures:[], total_open_qty:0, total_positions:0 });
    }
    setBfLoading(false);
  },[]);
  const loadHoldings = useCallback(async () => {
    if(firstLoadRef.current) setHoldingsLoading(true); try{const r=await getHoldings();setHoldingsData(r.data);}catch{setHoldingsData({holdings:[],total_holdings:0,total_value:0});} setHoldingsLoading(false);
  },[]);
  const loadDay = useCallback(async () => {
    if(firstLoadRef.current) setDayLoading(true); try{const r=await getDayPositions();setDayData(r.data);}catch{setDayData({positions:[],total:0});} setDayLoading(false);
  },[]);
  useEffect(() => {
    // Initial load — run ALL in parallel so fastest data shows first
    Promise.all([loadData(), loadBF(), loadHoldings(), loadDay()])
      .finally(() => { firstLoadRef.current = false; });
    // Silent background refresh every 60s — no spinners, no blinking
    const iv = setInterval(() => { loadData(); loadBF(); loadHoldings(); loadDay(); }, 90000);
    return () => clearInterval(iv);
  },[loadData,loadBF,loadHoldings,loadDay]);

  /* ── Net position merge ──────────────────────────────────────────────────*/
  const dayPositions = dayData?.positions||[];
  const dayEquity    = dayPositions.filter(p=>p.instrument_type==='EQUITY');
  const dayOptions   = dayPositions.filter(p=>p.instrument_type==='OPTIONS');
  const dayFutures   = dayPositions.filter(p=>p.instrument_type==='FUTURES');
  const dayTotalNet  = dayPositions.reduce((s,p)=>s+(Number(p.net_qty)||0),0);
  const bfOptions    = bfData?.options||[];
  const bfFutures    = bfData?.futures||[];

  const mergeKey = (sym,exp,str,opt) => `${sym}|${(exp||'').slice(0,10)}|${str||''}|${opt||''}`;
  const netMap = new Map();
  ;[...bfOptions,...bfFutures].forEach(pos=>{
    const key=mergeKey(pos.symbol,pos.expiry_date,pos.strike_price,pos.option_type);
    // Support all qty field names from backend
    const rawNet = Number(pos.qty_in_lots ?? pos.total_open_qty ?? 0);
    const lngQty = Number(pos.opng_lng_qty  ?? 0);
    const shrtQty= Number(pos.opng_shrt_qty ?? 0);
    // Use opng_lng/shrt if explicit, otherwise interpret rawNet as long
    const bfBuy  = lngQty  > 0 ? lngQty  : (rawNet > 0 ? rawNet  : 0);
    const bfSell = shrtQty > 0 ? shrtQty : (rawNet < 0 ? -rawNet : 0);
    if(!netMap.has(key)) netMap.set(key,{symbol:pos.symbol,exchange:pos.exchange,segment:pos.segment||'FO',expiry_date:pos.expiry_date,strike_price:pos.strike_price,option_type:pos.option_type,instrument_type:pos.instrument_type,total_buy:bfBuy,total_sell:bfSell});
    else{const e=netMap.get(key);e.total_buy+=bfBuy;e.total_sell+=bfSell;}
  });
  ;[...dayOptions,...dayFutures].forEach(pos=>{
    const key=mergeKey(pos.symbol,pos.expiry_date,pos.strike_price,pos.option_type);
    const dBuy=Number(pos.buy_qty)||0; const dSell=Number(pos.sell_qty)||0;
    if(!netMap.has(key)) netMap.set(key,{symbol:pos.symbol,exchange:pos.exchange,segment:pos.segment||'FO',expiry_date:pos.expiry_date,strike_price:pos.strike_price,option_type:pos.option_type,instrument_type:pos.instrument_type,total_buy:dBuy,total_sell:dSell});
    else{const e=netMap.get(key);e.total_buy+=dBuy;e.total_sell+=dSell;}
  });
  const netFOPositions = Array.from(netMap.values())
    .map(p=>({...p,net_qty:p.total_buy-p.total_sell}))
    .filter(p=>p.total_buy>0||p.total_sell>0);

  const netCount=positions.filter(p=>(p.instrument_type||'').toUpperCase()!=='EQUITY').length+netFOPositions.length;
  const bfCount=(bfData?.options?.length||0)+(bfData?.futures?.length||0);
  const holdingsCount=holdingsData?.total_holdings??0;

  /* ── Sq-off handlers ─────────────────────────────────────────────────────*/
  const handleSquareOff      = p => setConfirmModal({...p,side:p.net_qty>0?'SELL':'BUY',quantity:Math.abs(p.net_qty),isHolding:false,isDayEquity:false});
  const handleHoldingSquareOff = h => setConfirmModal({symbol:`${h.company_name} ; ${h.isin}`,exchange:'NSE',segment:'CM',side:'SELL',quantity:h.quantity,displayName:`${h.company_name} ; ${h.isin}`,isin:h.isin,isHolding:true});
  const handleDayEquitySquareOff = p => setConfirmModal({symbol:p.symbol,exchange:p.exchange,segment:p.segment,side:Number(p.net_qty)>0?'SELL':'BUY',quantity:Math.abs(Number(p.net_qty)),isHolding:false,isDayEquity:true,dayKey:p.symbol+'_'+p.exchange+'_'+p.segment});
  const handleFOSquareOff    = p => setConfirmModal({symbol:p.symbol,exchange:p.exchange,segment:p.segment||'FO',side:Number(p.net_qty)>0?'SELL':'BUY',quantity:Math.abs(Number(p.net_qty)),isHolding:false,isDayEquity:false,foKey:`${p.symbol}|${p.exchange}|${p.segment||'FO'}|${p.expiry_date||''}|${p.strike_price||''}|${p.option_type||''}`,expiry_date:p.expiry_date||null,strike_price:p.strike_price||null,option_type:p.option_type||null});

  const confirmSquareOff = async () => {
    setPlacing(true);
    try {
      if(confirmModal.isHolding){
        await placeHoldingsSquareOff({exchange:confirmModal.exchange,segment:confirmModal.segment,symbol:confirmModal.symbol,quantity:confirmModal.quantity,side:'SELL'});
        setPlacedHoldings(p=>({...p,[confirmModal.isin]:true}));
        // Also mark in placedFO so holdings button disables immediately
        const hKey = `${confirmModal.symbol}|${confirmModal.exchange}|${confirmModal.segment}`;
        setPlacedFO(p=>({...p,[hKey]:true}));
        setMessage(`Square-off placed for ${confirmModal.displayName}. RMS team notified.`);
      } else {
        await placeSquareOff({
          exchange:     confirmModal.exchange,
          segment:      confirmModal.segment,
          symbol:       confirmModal.symbol,
          quantity:     confirmModal.quantity,
          side:         confirmModal.side,
          expiry_date:  confirmModal.expiry_date  || null,
          strike_price: confirmModal.strike_price || null,
          option_type:  confirmModal.option_type  || null,
        });
        if(confirmModal.isDayEquity) {
          setPlacedDayEquity(p=>({...p,[confirmModal.dayKey]:true}));
        } else {
          // Mark F&O net position as placed so button disables immediately
          // Use confirmModal.foKey directly — it already includes the full
          // contract identity (expiry/strike/option_type), don't rebuild it
          // here without those fields or this fix is silently undone.
          const foKey = confirmModal.foKey || `${confirmModal.symbol}|${confirmModal.exchange}|${confirmModal.segment}`;
          setPlacedFO(p=>({...p,[foKey]:true}));
        }
        setMessage(`Square-off placed for ${confirmModal.symbol}. RMS team notified.`);
        // Refresh only orders in background — full loadData() causes tab blink
        getMyOrders().then(o => setOrders(o.data.orders||[])).catch(()=>{});
      }
      setMessageType('success'); setConfirmModal(null);
    } catch(err) {
      // ── FIX: axios wraps backend errors in err.response.data
      // err.message = "Request failed with status code 403" (generic axios)
      // err.response.data.error = "SEGMENT_DISABLED" (actual backend error code)
      // Must check backend payload first, not axios generic message
      const backendError   = err.response?.data?.error   || '';
      const backendMessage = err.response?.data?.message  || '';
      const axiosMsg       = err.message || '';

      const isBlocked =
        backendError.includes('SEGMENT_DISABLED')  ||
        backendError.includes('SSO_BLOCKED')        ||
        backendMessage.includes('trading application is functioning') ||
        axiosMsg.includes('trading application is functioning');

      // Duplicate order — show clear message, don't show ssoBlockModal
      if (backendError.includes('DUPLICATE_ORDER') || backendError.includes('already been placed')) {
        setMessage('A square-off order already exists for this security.');
        setMessageType('error'); setConfirmModal(null);
        setPlacing(false); return;
      }

      if(isBlocked){
        setConfirmModal(null); setPlacing(false); setSsoBlockModal(true); return;
      }

      // Show meaningful error — prefer backend message over axios generic
      const displayMsg = backendMessage || backendError || axiosMsg || 'Failed to place order. Please try again.';
      setMessage(displayMsg); setMessageType('error'); setConfirmModal(null);
    }
    setPlacing(false);
    setTimeout(()=>setMessage(''),6000);
  };

  /* ── Style helpers ────────────────────────────────────────────────────────*/
  const btnH = largeTT ? 48 : 40;
  const s = {
    page:      { minHeight:'100vh', background:T.bg, fontFamily:"'DM Sans',-apple-system,sans-serif", fontSize:fs, color:T.tx },
    topBar:    { background:T.surf, borderBottom:`0.5px solid ${T.bdr}`, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 24px', height:54, position:'sticky', top:0, zIndex:50 },
    logoImg:   { height:28, width:'auto', objectFit:'contain' },
    brandName: { fontSize:13, fontWeight:600, color:T.tx },
    brandSub:  { fontSize:10, color:T.tx3 },
    iconBtn:   { width:largeTT?40:32, height:largeTT?40:32, background:T.surf2, border:`0.5px solid ${T.bdr}`, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:T.tx2, flexShrink:0 },
    avatarBtn: { width:largeTT?40:34, height:largeTT?40:34, background:T.brandL, border:`1.5px solid ${T.brand}`, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:12, fontWeight:600, color:T.brand, flexShrink:0 },
    alertBar:  { background:T.warnBg, borderBottom:`0.5px solid ${T.warn}`, padding:'9px 24px', fontSize:fs-2, color:T.warnTx, display:'flex', alignItems:'center', gap:8 },
    body:      { padding:isMobile?14:20, paddingLeft:isMobile?14:24, paddingRight:isMobile?14:24 },
    statGrid:  { display:'grid', gridTemplateColumns:isMobile?'repeat(2,1fr)':'repeat(5,1fr)', gap:10, marginBottom:16 },
    statCard:  (sel) => ({ background:sel?T.brandL:T.surf, border:`0.5px solid ${sel?T.brand:T.bdr}`, borderRadius:12, padding:'13px 15px', cursor:'pointer', transition:'border-color .15s' }),
    statTag:   (bg,col) => ({ display:'inline-block', fontSize:9, fontWeight:600, letterSpacing:'.05em', padding:'2px 7px', borderRadius:4, marginBottom:7, background:bg, color:col }),
    statNum:   (sel) => ({ fontSize:24, fontWeight:500, lineHeight:1, color:sel?T.brand:T.tx }),
    statLbl:   { fontSize:11, color:T.tx2, marginTop:3 },
    tabRow:    { display:'flex', background:T.surf, border:`0.5px solid ${T.bdr}`, borderRadius:8, overflow:'hidden', marginBottom:16 },
    tabPill:   (act,last) => ({ flex:1, border:'none', background:act?T.brand:'transparent', padding:`10px ${isMobile?'4':'8'}px`, fontSize:isMobile?10:12, fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", color:act?'#fff':T.tx2, borderRight:last?'none':`0.5px solid ${T.bdr}`, transition:'.15s' }),
    tcard:     { background:T.surf, border:`0.5px solid ${T.bdr}`, borderRadius:12, overflow:'hidden', marginBottom:14 },
    th:        { background:T.surf2, borderBottom:`0.5px solid ${T.bdr}`, color:T.tx2, fontSize:10, fontWeight:600, padding:'9px 13px', textAlign:'left', textTransform:'uppercase', letterSpacing:'.04em', whiteSpace:'nowrap' },
    td:        { color:T.tx, fontSize:fs-1, padding:'11px 13px', verticalAlign:'middle', borderBottom:`0.5px solid ${T.bdr}` },
    sqBtn:     (sm) => ({ background:T.err, color:'#fff', border:'none', borderRadius:sm?6:8, padding:sm?'6px 12px':'11px', fontSize:sm?12:fs-1, fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", display:'flex', alignItems:'center', justifyContent:'center', gap:6, width:sm?'auto':'100%', minHeight:sm?32:btnH, transition:'opacity .15s' }),
    flatDisabled: { background:T.surf2, color:T.tx3, border:`0.5px solid ${T.bdr}`, borderRadius:6, padding:'6px 12px', fontSize:12, cursor:'not-allowed', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' },
    exchBadge: (exch) => {
      const m={NSE:{bg:T.brandL,col:T.brandD},BSE:{bg:T.warnBg,col:T.warnTx},MCX:{bg:'#EEEDFE',col:'#3C3489'}};
      const c=m[exch]||m.NSE;
      return {fontSize:9,fontWeight:600,padding:'2px 6px',borderRadius:4,background:c.bg,color:c.col};
    },
    typePill:  (opt) => {
      if(opt==='CE') return {background:T.cePill.bg,color:T.cePill.tx,border:`0.5px solid ${T.cePill.bdr}`,borderRadius:4,fontSize:10,fontWeight:600,padding:'3px 8px'};
      if(opt==='PE') return {background:T.pePill.bg,color:T.pePill.tx,border:`0.5px solid ${T.pePill.bdr}`,borderRadius:4,fontSize:10,fontWeight:600,padding:'3px 8px'};
      return {background:T.futPill.bg,color:T.futPill.tx,border:`0.5px solid ${T.futPill.bdr}`,borderRadius:4,fontSize:10,fontWeight:600,padding:'3px 8px'};
    },
    sumBar:    { background:T.surf, border:`0.5px solid ${T.bdr}`, borderRadius:'12px 12px 0 0', display:'flex', flexWrap:'wrap', borderBottom:`0.5px solid ${T.bdr}` },
    sumItem:   { padding:'11px 16px', display:'flex', flexDirection:'column', gap:2, borderRight:`0.5px solid ${T.bdr}` },
    sumLbl:    { fontSize:9, fontWeight:600, color:T.tx3, textTransform:'uppercase', letterSpacing:'.05em' },
    sumVal:    (col) => ({ fontSize:19, fontWeight:500, color:col||T.tx }),
    vonly:     { background:T.warnBg, border:`0.5px solid ${T.warn}`, color:T.warnTx, borderRadius:6, fontSize:11, fontWeight:500, padding:'6px 12px', whiteSpace:'nowrap', display:'flex', alignItems:'center', margin:'auto 0' },
    overlay:   { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 },
    modal:     { background:T.surf, borderRadius:16, width:'100%', maxWidth:440, border:`0.5px solid ${T.bdr2}`, display:'flex', flexDirection:'column' },
    drawer:    { position:'fixed', bottom:0, left:'50%', transform:'translateX(-50%)', width:'min(500px,100%)', background:T.surf, borderRadius:'20px 20px 0 0', border:`0.5px solid ${T.bdr2}`, zIndex:201, maxHeight:'85vh', overflowY:'auto' },
    secHdr:    { display:'flex', alignItems:'center', gap:8, margin:'0 0 10px' },
    secTtl:    { fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'.08em', color:T.tx2 },
    secBdg:    { fontSize:10, fontWeight:600, padding:'2px 8px', borderRadius:4, background:T.brandL, color:T.brandD },
    secCnt:    { background:T.surf2, color:T.tx2, fontSize:10, padding:'2px 7px', borderRadius:10, fontWeight:600 },
    secLn:     { flex:1, height:1, background:T.bdr },
    emptyState:{ color:T.tx3, fontSize:fs, padding:48, textAlign:'center' },
    msgBanner: { margin:'10px 24px 0', borderRadius:8, padding:'10px 14px', fontSize:fs-1 },
    placedBdg: { background:T.warnBg, border:`0.5px solid ${T.warn}`, borderRadius:6, color:T.warnTx, fontSize:10, fontWeight:500, padding:'4px 10px', whiteSpace:'nowrap' },
    tog:       (on) => ({ width:42, height:24, borderRadius:99, position:'relative', cursor:'pointer', background:on?T.brand:T.bdr2, flexShrink:0, border:'none', transition:'background .2s' }),
    togThumb:  (on) => ({ width:18, height:18, background:'#fff', borderRadius:'50%', position:'absolute', top:3, left:on?21:3, transition:'left .18s' }),
    footer:    { color:T.tx3, fontSize:11, textAlign:'center', padding:'18px 0 24px', lineHeight:1.7 },
    footerLnk: { color:T.brand, textDecoration:'none' },
  };

  /* ── Reusable atoms ──────────────────────────────────────────────────────*/
  const Toggle = ({on, onToggle, label}) => (
    <div role="switch" aria-checked={on} aria-label={label} tabIndex={0}
      style={s.tog(on)} onClick={onToggle}
      onKeyDown={e=>(e.key==='Enter'||e.key===' ')&&onToggle()}>
      <div style={s.togThumb(on)}/>
    </div>
  );
  const QtyDisplay = ({v}) => {
    const n=Number(v);
    if(n>0) return <span style={{color:T.ok,fontWeight:500}}>+{fmtQty(n)}</span>;
    if(n<0) return <span style={{color:T.err,fontWeight:500}}>{fmtQty(n)}</span>;
    return <span style={{color:T.flat}}>0</span>;
  };
  const ExchBadge = ({exchange,segment}) => <span style={s.exchBadge(exchange)}>{exchange}{segment?` ${segment}`:''}</span>;
  const SectionHdr = ({title,badge,count}) => (
    <div style={s.secHdr}>
      <span style={s.secTtl}>{title}</span>
      {badge && <span style={s.secBdg}>{badge}</span>}
      <span style={s.secCnt}>{count}</span>
      <div style={s.secLn}/>
    </div>
  );

  // Client-visible orders only (exclude internal FILE_GENERATED status)
  const clientVisibleOrders = orders.filter(o => {
    const st = (o.status||'').toUpperCase();
    return st==='ORDER_RECEIVED'||st==='RECEIVED'||st==='FILE_GENERATED'||st==='TRADED'||st==='ORDER_TRADED'||st==='REJECTED'||st==='FAILED';
  });
  const tabs = [
    {key:'positions',label:'Net',     full:'Net position',  count:netCount},
    {key:'day',      label:'Day',     full:'Day position',  count:dayPositions.length},
    {key:'bf',       label:'B/F',     full:'B/F position',  count:bfCount},
    {key:'holdings', label:'Holdings',full:'Holdings',      count:holdingsCount},
    {key:'orders',   label:'Orders',  full:'My orders',     count:clientVisibleOrders.length},
  ];

  /* ──────────────────────────────────────────────────────────────────────────
     RENDER
  ────────────────────────────────────────────────────────────────────────── */
  return (
    <div style={s.page}>

      {/* ── Confirm modal ── */}
      {confirmModal && (
        <div style={s.overlay} role="dialog" aria-modal="true">
          <div style={s.modal} className="nb-slide-up">
            <div style={{padding:'18px 20px 14px',borderBottom:`0.5px solid ${T.bdr}`}}>
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <div style={{width:36,height:36,background:T.errBg,border:`0.5px solid ${T.err}`,borderRadius:9,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={T.err} strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                </div>
                <div>
                  <div style={{fontSize:fs+1,fontWeight:600,color:T.tx}}>Confirm square-off</div>
                  <div style={{fontSize:11,color:T.tx2,marginTop:2}}>This action cannot be undone</div>
                </div>
              </div>
            </div>
            <div style={{padding:'16px 20px'}}>
              <div style={{background:T.surf2,border:`0.5px solid ${T.bdr}`,borderRadius:8,overflow:'hidden',marginBottom:13}}>
                {[
                  {label:'Symbol',    value:confirmModal.displayName||confirmModal.symbol},
                  {label:'Exchange',  value:`${confirmModal.exchange} / ${confirmModal.segment}`},
                  {label:'Side',      value:confirmModal.side, col:T.err},
                  {label:'Quantity',  value:confirmModal.quantity},
                  {label:'Order type',value:'Market'},
                ].map((r,i)=>(
                  <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'9px 13px',borderBottom:i<4?`0.5px solid ${T.bdr}`:'none'}}>
                    <span style={{fontSize:12,color:T.tx2}}>{r.label}</span>
                    <span style={{fontSize:12,fontWeight:500,color:r.col||T.tx}}>{r.value}</span>
                  </div>
                ))}
              </div>
              <div style={{background:T.errBg,border:`0.5px solid ${T.err}`,borderRadius:8,color:T.errTx,fontSize:12,padding:'9px 12px',lineHeight:1.6}}>
                Order executes at market price and cannot be cancelled after placing.
              </div>
            </div>
            <div style={{padding:'12px 20px 18px',borderTop:`0.5px solid ${T.bdr}`,display:'flex',gap:10}}>
              <button className="nb-btn" style={{flex:1,height:40,background:'transparent',border:`0.5px solid ${T.bdr2}`,borderRadius:8,color:T.tx,fontSize:13,cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}} onClick={()=>setConfirmModal(null)} disabled={placing}>Cancel</button>
              <button className="nb-btn" style={{flex:2,height:40,background:T.err,border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}} onClick={confirmSquareOff} disabled={placing}>{placing?'Placing…':'Confirm square-off'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── SSO block modal ── */}
      {ssoBlockModal && (
        <div style={s.overlay} role="alertdialog" aria-modal="true">
          <div style={{...s.modal,maxWidth:400}} className="nb-slide-up">
            <div style={{padding:'18px 20px 14px',borderBottom:`0.5px solid ${T.bdr}`}}>
              <div style={{fontSize:15,fontWeight:600,color:T.tx}}>Square-off unavailable</div>
              <div style={{fontSize:12,color:T.tx2,marginTop:2}}>Trading platform is functioning</div>
            </div>
            <div style={{padding:'16px 20px'}}>
              <div style={{background:T.warnBg,border:`0.5px solid ${T.warn}`,borderRadius:8,padding:16,color:T.warnTx,fontSize:fs-1,lineHeight:1.7}}>
                It seems our trading application is functioning. Square-off via Navia Backup is only available during platform downtime.
              </div>
            </div>
            <div style={{padding:'12px 20px 18px',borderTop:`0.5px solid ${T.bdr}`}}>
              <button className="nb-btn" style={{width:'100%',height:40,background:T.brand,border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}} onClick={()=>setSsoBlockModal(false)}>OK, understood</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Profile drawer ── */}
      {showProfile && (
        <>
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:200}} onClick={()=>setShowProfile(false)}/>
          <div style={s.drawer} className="nb-slide-up" role="dialog" aria-modal="true" aria-label="Account profile">
            <div style={{width:36,height:4,background:T.bdr2,borderRadius:99,margin:'12px auto'}}/>
            <div style={{padding:'4px 20px 14px',borderBottom:`0.5px solid ${T.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{fontSize:15,fontWeight:600,color:T.tx}}>My account</div>
              <button style={{...s.iconBtn,background:'transparent'}} onClick={()=>setShowProfile(false)}>✕</button>
            </div>
            <div style={{padding:'18px 20px',borderBottom:`0.5px solid ${T.bdr}`,display:'flex',alignItems:'center',gap:13}}>
              <div style={{width:50,height:50,background:T.brandL,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:17,fontWeight:600,color:T.brand,flexShrink:0}}>{getInitials(client.name)}</div>
              <div>
                <div style={{fontSize:15,fontWeight:600,color:T.tx}}>{client.name}</div>
                <div style={{fontSize:12,color:T.tx2,marginTop:2}}>UCC: {client.ucc}</div>
                <div style={{fontSize:10,fontWeight:500,background:T.okBg,color:T.okTx,borderRadius:99,padding:'2px 9px',display:'inline-block',marginTop:5}}>Account active</div>
              </div>
            </div>
            {[
              {icon:'🪪', label:'Client code', value:(profileData||client).ucc||'—'},
              {icon:'📅', label:'Date of birth', value:(profileData||client).dob ? new Date((profileData||client).dob).toLocaleDateString('en-IN',{day:'2-digit',month:'2-digit',year:'numeric'}) : '—'},
              {icon:'📱', label:'Mobile', value:(profileData?.mobile||client.mobile) ? `+91 ••••••${String(profileData?.mobile||client.mobile).slice(-4)}` : '—'},
              {icon:'✉',  label:'Email', value:(profileData?.email||client.email) ? `${(profileData?.email||client.email).charAt(0)}${'*'.repeat(5)}@${(profileData?.email||client.email).split('@')[1]||'—'}` : '—'},
            ].map((r,i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 20px',borderBottom:`0.5px solid ${T.bdr}`,fontSize:13}}>
                <span style={{color:T.tx2,display:'flex',alignItems:'center',gap:8}}><span>{r.icon}</span>{r.label}</span>
                <span style={{fontWeight:500,color:T.tx}}>{r.value}</span>
              </div>
            ))}
            <div style={{padding:'14px 20px',borderBottom:`0.5px solid ${T.bdr}`,background:T.surf2}}>
              <div style={{fontSize:11,fontWeight:600,color:T.tx2,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:10}}>Need help?</div>
              <a href="mailto:support@navia.co.in" style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:T.brand,textDecoration:'none',marginBottom:8}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                support@navia.co.in
              </a>
              <a href="https://support.navia.co.in" target="_blank" rel="noreferrer" style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:T.brand,textDecoration:'none'}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
                support.navia.co.in
              </a>
            </div>
            <div style={{padding:'12px 20px 22px'}}>
              <button className="nb-btn" style={{width:'100%',background:T.errBg,color:T.err,border:`0.5px solid ${T.err}`,borderRadius:8,padding:12,fontSize:13,fontWeight:500,cursor:'pointer',fontFamily:"'DM Sans',sans-serif",display:'flex',alignItems:'center',justifyContent:'center',gap:8}} onClick={onLogout}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                Sign out
              </button>
            </div>
          </div>
        </>
      )}

      {/* ── Help popup ── */}
      {showHelp && (
        <div style={{...s.overlay,zIndex:2000}} role="dialog" aria-modal="true" onClick={e=>e.target===e.currentTarget&&setShowHelp(false)}>
          <div style={{...s.modal,maxWidth:380}} className="nb-slide-up">
            <div style={{padding:'18px 20px 14px',borderBottom:`0.5px solid ${T.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{fontSize:15,fontWeight:600,color:T.tx}}>Need help?</div>
              <button style={{...s.iconBtn,background:'transparent'}} onClick={()=>setShowHelp(false)}>✕</button>
            </div>
            <div style={{padding:'18px 20px',display:'flex',flexDirection:'column',gap:12}}>
              {[
                {icon:<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={T.brand} strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>, label:'Support portal', sub:'support.navia.co.in', href:'https://support.navia.co.in'},
                {icon:<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={T.brand} strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, label:'Email support', sub:'support@navia.co.in', href:'mailto:support@navia.co.in'},
              ].map((item,i)=>(
                <a key={i} href={item.href} target="_blank" rel="noreferrer"
                  style={{display:'flex',alignItems:'center',gap:14,padding:'13px 15px',background:T.surf2,border:`0.5px solid ${T.bdr}`,borderRadius:10,textDecoration:'none',transition:'.15s'}}>
                  <div style={{width:38,height:38,background:T.brandL,borderRadius:9,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{item.icon}</div>
                  <div>
                    <div style={{fontSize:13,fontWeight:500,color:T.tx,marginBottom:2}}>{item.label}</div>
                    <div style={{fontSize:12,color:T.brand}}>{item.sub}</div>
                  </div>
                </a>
              ))}
            </div>
            <div style={{padding:'0 20px 18px'}}>
              <button className="nb-btn" style={{width:'100%',height:40,background:'transparent',border:`0.5px solid ${T.bdr2}`,borderRadius:8,color:T.tx,fontSize:13,cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}} onClick={()=>setShowHelp(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Accessibility drawer ── */}
      {showA11y && (
        <>
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:200}} onClick={()=>setShowA11y(false)}/>
          <div style={s.drawer} className="nb-slide-up" role="dialog" aria-modal="true" aria-label="Accessibility settings">
            <div style={{width:36,height:4,background:T.bdr2,borderRadius:99,margin:'12px auto'}}/>
            <div style={{padding:'4px 20px 14px',borderBottom:`0.5px solid ${T.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{fontSize:15,fontWeight:600,color:T.tx}}>Accessibility settings</div>
              <button style={{...s.iconBtn,background:'transparent'}} onClick={()=>setShowA11y(false)}>✕</button>
            </div>
            {/* Font size */}
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 20px',borderBottom:`0.5px solid ${T.bdr}`}}>
              <div><div style={{fontSize:14,fontWeight:500,color:T.tx}}>Text size</div><div style={{fontSize:11,color:T.tx2,marginTop:2}}>12 – 20px range</div></div>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <button style={{width:32,height:32,border:`0.5px solid ${T.bdr2}`,borderRadius:'50%',background:T.surf2,cursor:'pointer',fontSize:17,display:'flex',alignItems:'center',justifyContent:'center',color:T.tx}} onClick={()=>setFontSize(f=>Math.max(12,f-1))}>−</button>
                <span style={{fontSize:13,fontWeight:500,color:T.tx,minWidth:34,textAlign:'center'}} aria-live="polite">{fontSize}px</span>
                <button style={{width:32,height:32,border:`0.5px solid ${T.bdr2}`,borderRadius:'50%',background:T.surf2,cursor:'pointer',fontSize:17,display:'flex',alignItems:'center',justifyContent:'center',color:T.tx}} onClick={()=>setFontSize(f=>Math.min(20,f+1))}>+</button>
              </div>
            </div>
            {/* Theme */}
            <div style={{padding:'14px 20px',borderBottom:`0.5px solid ${T.bdr}`}}>
              <div style={{fontSize:13,fontWeight:500,color:T.tx,marginBottom:10}}>Colour theme</div>
              <div style={{display:'flex',gap:8}}>
                {[{k:'light',l:'☀ Light',bg:'#fff',col:'#0D0F12'},{k:'dark',l:'🌙 Dark',bg:'#141928',col:'#F0F4FF'},{k:'hc',l:'⬤ High contrast',bg:'#000',col:'#fff'}].map(t=>(
                  <button key={t.k} onClick={()=>setThemeKey(t.k)} aria-pressed={themeKey===t.k}
                    style={{flex:1,padding:'9px 5px',borderRadius:8,fontSize:11,fontWeight:500,cursor:'pointer',fontFamily:"'DM Sans',sans-serif",border:`1.5px solid ${themeKey===t.k?T.brand:'transparent'}`,background:t.bg,color:t.col}}>{t.l}</button>
                ))}
              </div>
            </div>
            {[
              {label:'Reduce motion',sub:'Minimise animations',val:reduceMotion,set:setReduceMotion},
              {label:'Larger tap targets',sub:'Bigger buttons for touch',val:largeTT,set:setLargeTT},
              {label:'Focus indicators',sub:'Always show keyboard focus ring',val:focusRing,set:setFocusRing},
            ].map((row,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 20px',borderBottom:`0.5px solid ${T.bdr}`}}>
                <div><div style={{fontSize:13,fontWeight:500,color:T.tx}}>{row.label}</div><div style={{fontSize:11,color:T.tx2,marginTop:2}}>{row.sub}</div></div>
                <Toggle on={row.val} onToggle={()=>row.set(v=>!v)} label={row.label}/>
              </div>
            ))}
            <div style={{padding:'13px 20px 22px',background:T.surf2,borderRadius:'0 0 20px 20px',fontSize:11,color:T.tx2,lineHeight:1.7}}>
              ℹ Navia Backup targets WCAG 2.1 AA compliance. All square-off actions require explicit confirmation.
            </div>
          </div>
        </>
      )}

      {/* ── Top bar ── */}
      <header style={s.topBar}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <div style={{
            background:'#fff',borderRadius:8,padding:'4px 12px',
            display:'flex',alignItems:'center',justifyContent:'center',
            flexShrink:0,boxShadow:'0 1px 4px rgba(0,0,0,.12)'
          }}>
            <img src={NAVIA_LOGO}
              style={{height:24,width:'auto',objectFit:'contain',display:'block'}}
              alt="Navia Markets"
            />
          </div>
          <div>
            <div style={s.brandName}>Navia Backup</div>
            <div style={s.brandSub}>UCC: {client.ucc}</div>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <button style={s.iconBtn} className="nb-btn" onClick={()=>setShowHelp(true)} aria-label="Need help?">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          </button>
          <button style={s.iconBtn} className="nb-btn" onClick={()=>setShowA11y(true)} aria-label="Accessibility settings">♿</button>
          <button style={s.avatarBtn} className="nb-btn" onClick={()=>setShowProfile(true)} aria-label={`Profile: ${client.name}`}>{getInitials(client.name)}</button>
        </div>
      </header>

      {/* ── Alert strip ── */}
      <div style={s.alertBar} role="alert">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0}}><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        Market orders only &nbsp;·&nbsp; Square-off once per security &nbsp;·&nbsp; Trades will not reflect in main app immediately &nbsp;·&nbsp; Do not repeat trades when main platform resumes
      </div>

      {/* ── Message banner ── */}
      {message && (
        <div style={{...s.msgBanner,background:messageType==='success'?T.okBg:T.errBg,border:`0.5px solid ${messageType==='success'?T.ok:T.err}`,color:messageType==='success'?T.okTx:T.errTx}} role="status" className="nb-fade">
          {message}
        </div>
      )}

      {/* ── Main ── */}
      <main style={s.body}>
        {/* Stat cards */}
        <div style={s.statGrid}>
          {[
            {key:'positions',label:'Net positions', count:netCount,    tagBg:T.brandL,tagCol:T.brandD},
            {key:'day',      label:'Day trades',    count:dayLoading?'…':dayPositions.length, tagBg:'#E8F5E9',tagCol:'#27500A'},
            {key:'bf',       label:'Carried fwd',   count:bfLoading?'…':bfCount,  tagBg:'#FFF8E1',tagCol:'#633806'},
            {key:'holdings', label:'Holdings',      count:holdingsLoading?'…':holdingsCount, tagBg:'#EEEDFE',tagCol:'#3C3489'},
          ].map(card=>(
            <div key={card.key} style={s.statCard(activeTab===card.key)} className="nb-card-hov nb-btn"
              onClick={()=>setActiveTab(card.key)} tabIndex={0} role="button" aria-pressed={activeTab===card.key}
              onKeyDown={e=>e.key==='Enter'&&setActiveTab(card.key)}>
              <div style={s.statTag(card.tagBg,card.tagCol)}>{card.key==='positions'?'NET':card.key==='day'?'DAY':card.key==='bf'?'B/F':'HOL'}</div>
              <div style={s.statNum(activeTab===card.key)}>{card.count}</div>
              <div style={s.statLbl}>{card.label}</div>
            </div>
          ))}
          <div style={{...s.statCard(false),background:T.okBg,borderColor:T.ok,cursor:'default',...(isMobile?{gridColumn:'1 / -1'}:{})}}>
            <div style={s.statTag(T.okBg,T.okTx)}>LIVE</div>
            <div style={{fontSize:20,fontWeight:500,color:T.ok}}>Active</div>
            <div style={{...s.statLbl,color:T.okTx}}>Emergency mode on</div>
          </div>
        </div>

        {/* Tab bar */}
        <nav style={s.tabRow}>
          {tabs.map((t,i)=>(
            <button key={t.key} style={s.tabPill(activeTab===t.key,i===tabs.length-1)}
              onClick={()=>setActiveTab(t.key)} aria-current={activeTab===t.key?'page':undefined}>
              {isMobile?t.label:t.full}
              <span style={{marginLeft:4,fontSize:9,opacity:.7}}>({t.count})</span>
            </button>
          ))}
        </nav>

        {/* ── REFRESH BAR ── */}
        <div style={{display:'flex', justifyContent:'flex-end', padding:'8px 0 2px'}}>
          <button
            onClick={async ()=>{
              // Set loading for ALL tabs so spinner shows regardless of active tab
              setLoading(true);
              setBfLoading(true);
              setDayLoading(true);
              setHoldingsLoading(true);
              await Promise.all([loadData(), loadBF(), loadHoldings(), loadDay()]);
              setLoading(false);
              setBfLoading(false);
              setDayLoading(false);
              setHoldingsLoading(false);
            }}
            style={{display:'flex',alignItems:'center',gap:6,background:T.brandL,border:`1px solid ${T.brand}`,borderRadius:8,padding:'7px 18px',fontSize:12,fontWeight:600,color:T.brand,cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}}>
            ↻ Refresh data
          </button>
        </div>

        {/* ── NET POSITION TAB — FAO ONLY (per spec: EQ sq-off is via Day positions tab) ── */}
        {activeTab==='positions' && (
          <div className="nb-fade">
            {loading
              ? <div style={s.emptyState}>Loading positions…</div>
              : <>
                  {(() => {
                    const faoPositions = positions.filter(p => (p.instrument_type||'').toUpperCase() !== 'EQUITY');
                    return faoPositions.length>0 && (
                    <>
                      <SectionHdr title="Open positions" badge="Live" count={faoPositions.length}/>
                      <div style={s.tcard}>
                        <div style={{overflowX:'auto'}}>
                          <table style={{width:'100%',borderCollapse:'collapse',minWidth:560}}>
                            <thead><tr>{['Exchange','Symbol & Strike','Expiry','Type','Net qty','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                            <tbody>
                              {faoPositions.map((pos,i)=>{
                                const foKey = `${pos.symbol}|${pos.exchange}|${pos.segment}|${pos.expiry_date||''}|${pos.strike_price||''}|${pos.option_type||''}`;
                                return (
                                <tr key={i} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                                  <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                                  <td style={{...s.td,fontWeight:600}}>
                                    {pos.symbol}
                                    {pos.strike_price ? <span style={{fontSize:10,color:T.tx2,marginLeft:4}}>₹{pos.strike_price} {pos.option_type||''}</span> : null}
                                  </td>
                                  <td style={{...s.td,fontSize:11,color:T.tx2}}>
                                    {pos.expiry_date ? new Date(pos.expiry_date).toLocaleDateString('en-IN') : '—'}
                                  </td>
                                  <td style={s.td}><span style={{...s.typePill(null),background:T.surf2,color:T.tx2,border:`0.5px solid ${T.bdr}`}}>{pos.option_type||'FUT'}</span></td>
                                  <td style={{...s.td,color:pos.net_qty>0?T.buy:T.sell,fontWeight:500}}>{pos.net_qty>0?'+':''}{pos.net_qty}</td>
                                  <td style={s.td}>
                                    {placedFO[foKey]
                                      ? <span style={s.placedBdg}>Order placed</span>
                                      : <button style={{...s.sqBtn(true)}} className="nb-btn" onClick={()=>handleFOSquareOff(pos)}>Square off</button>}
                                  </td>
                                </tr>
                              );})}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  );})()}
                  {netFOPositions.length>0 && (
                    <>
                      <SectionHdr title="F&O net positions" badge="B/F + Day combined" count={netFOPositions.length}/>
                      <div style={s.tcard}>
                        <div style={{overflowX:'auto'}}>
                          <table style={{width:'100%',borderCollapse:'collapse',minWidth:620}}>
                            <thead>
                              <tr>
                                {['Symbol & strike','Expiry','Type','Buy qty','Sell qty','Net qty','Exchange','Action'].map(h=>(
                                  <th key={h} style={s.th}>{h}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {netFOPositions.map((pos,i)=>{
                                const netQty=Number(pos.net_qty);
                                const isFlat=netQty===0;
                                return (
                                  <tr key={`net_${i}`} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                                    <td style={s.td}>
                                      <div style={{fontWeight:600,color:T.tx}}>{pos.symbol}</div>
                                      {pos.strike_price&&<div style={{fontSize:11,color:T.tx2}}>₹{formatStrike(pos.strike_price)}</div>}
                                    </td>
                                    <td style={{...s.td,fontSize:12,color:T.tx2}}>{formatExpiry(pos.expiry_date)}</td>
                                    <td style={s.td}><span style={s.typePill(pos.option_type)}>{pos.option_type||'FUT'}</span></td>
                                    <td style={{...s.td,color:T.buy,fontWeight:500}}>{fmtQty(pos.total_buy)}</td>
                                    <td style={{...s.td,color:T.sell,fontWeight:500}}>{fmtQty(pos.total_sell)}</td>
                                    <td style={s.td}><QtyDisplay v={netQty}/></td>
                                    <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                                    <td style={s.td}>
                                      {isFlat
                                        ? <button disabled style={s.flatDisabled}>Sq. Off not req.</button>
                                        : (placedFO[`${pos.symbol}|${pos.exchange}|${pos.segment||'FO'}|${pos.expiry_date||''}|${pos.strike_price||''}|${pos.option_type||''}`] || pos.squareoff_placed)
                                          ? <span style={s.placedBdg}>Order placed</span>
                                          : <button style={{...s.sqBtn(true)}} className="nb-btn" onClick={()=>handleFOSquareOff(pos)}>Square off</button>}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
                  {positions.filter(p=>(p.instrument_type||'').toUpperCase()!=='EQUITY').length===0&&netFOPositions.length===0&&<div style={s.emptyState}>No net position for the day.</div>}
                </>
            }
          </div>
        )}

        {/* ── DAY POSITION TAB ── */}
        {activeTab==='day' && (
          <div className="nb-fade">
            {dayLoading ? <div style={s.emptyState}>Loading day positions…</div>
            : dayPositions.length===0 ? <div style={s.emptyState}>No day positions found for today.</div>
            : <>
                <div style={s.sumBar}>
                  {[{l:'Total net',v:fmtQty(dayTotalNet),c:T.brand},{l:'Equity',v:dayEquity.length,c:T.buy},{l:'Options',v:dayOptions.length,c:'#7c3aed'},{l:'Futures',v:dayFutures.length,c:T.warn}].map((item,i)=>(
                    <div key={i} style={s.sumItem}><div style={s.sumLbl}>{item.l}</div><div style={s.sumVal(item.c)}>{item.v}</div></div>
                  ))}
                  <div style={{...s.sumItem,marginLeft:'auto'}}><div style={s.vonly}>Equity sq-off · F&O view only</div></div>
                </div>
                {dayEquity.length>0&&(<>
                  <SectionHdr title="Equity" badge="Cash market" count={dayEquity.length}/>
                  <div style={s.tcard}>
                    <div style={{overflowX:'auto'}}>
                      <table style={{width:'100%',borderCollapse:'collapse',minWidth:480}}>
                        <thead><tr>{['Symbol','Buy qty','Sell qty','Net qty','Exchange','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                          {dayEquity.map((pos,i)=>{
                            const dk=pos.symbol+'_'+pos.exchange+'_'+pos.segment;
                            const net=Number(pos.net_qty);
                            // Look up the real order for this symbol — net_qty=0 can mean
                            // either "genuinely flat, never traded" OR "successfully squared
                            // off and now closed" - these need different labels.
                            const ord = clientVisibleOrders.find(o =>
                              o.symbol===pos.symbol && o.exchange===pos.exchange && o.segment===pos.segment);
                            const ordSt = (ord?.status||'').toUpperCase();
                            return(<tr key={i} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                              <td style={{...s.td,fontWeight:600}}>{pos.symbol}</td>
                              <td style={{...s.td,color:T.buy,fontWeight:500}}>{fmtQty(pos.buy_qty)}</td>
                              <td style={{...s.td,color:T.sell,fontWeight:500}}>{fmtQty(pos.sell_qty)}</td>
                              <td style={s.td}><QtyDisplay v={pos.net_qty}/></td>
                              <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                              <td style={s.td}>
                                {(ordSt==='ORDER_TRADED'||ordSt==='TRADED')?<span style={{...s.placedBdg,background:T.okBg,color:T.ok}}>Traded</span>
                                  :ordSt==='PARTIALLY_TRADED'?<span style={{...s.placedBdg,background:'#FFFBEB',color:'#D97706'}}>Partially traded</span>
                                  :(ordSt==='ORDER_RECEIVED'||ordSt==='RECEIVED'||ordSt==='FILE_GENERATED')?<span style={s.placedBdg}>Order received</span>
                                  :placedDayEquity[dk]?<span style={s.placedBdg}>Order placed</span>
                                  :net===0?<button disabled style={s.flatDisabled}>Sq. Off not req.</button>
                                  :<button style={{...s.sqBtn(true)}} className="nb-btn" onClick={()=>handleDayEquitySquareOff(pos)}>Square off</button>}
                              </td>
                            </tr>);
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>)}
                {dayOptions.length>0&&(<>
                  <SectionHdr title="Options" badge="F&O · View only" count={dayOptions.length}/>
                  <div style={s.tcard}>
                    <div style={{overflowX:'auto'}}>
                      <table style={{width:'100%',borderCollapse:'collapse',minWidth:560}}>
                        <thead><tr>{['Symbol & strike','Expiry','Type','Buy qty','Sell qty','Net qty','Exchange'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                          {dayOptions.map((pos,i)=>(
                            <tr key={i} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                              <td style={s.td}><div style={{fontWeight:600}}>{pos.symbol}</div>{pos.strike_price&&<div style={{fontSize:11,color:T.tx2}}>₹{formatStrike(pos.strike_price)}</div>}</td>
                              <td style={{...s.td,fontSize:12,color:T.tx2}}>{formatExpiry(pos.expiry_date)}</td>
                              <td style={s.td}><span style={s.typePill(pos.option_type)}>{pos.option_type||'—'}</span></td>
                              <td style={{...s.td,color:T.buy,fontWeight:500}}>{fmtQty(pos.buy_qty)}</td>
                              <td style={{...s.td,color:T.sell,fontWeight:500}}>{fmtQty(pos.sell_qty)}</td>
                              <td style={s.td}><QtyDisplay v={pos.net_qty}/></td>
                              <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>)}
                {dayFutures.length>0&&(<>
                  <SectionHdr title="Futures" badge="F&O · View only" count={dayFutures.length}/>
                  <div style={s.tcard}>
                    <div style={{overflowX:'auto'}}>
                      <table style={{width:'100%',borderCollapse:'collapse',minWidth:480}}>
                        <thead><tr>{['Symbol','Expiry','Buy qty','Sell qty','Net qty','Exchange'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                          {dayFutures.map((pos,i)=>(
                            <tr key={i} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                              <td style={{...s.td,fontWeight:600}}>{pos.symbol}</td>
                              <td style={{...s.td,fontSize:12,color:T.tx2}}>{formatExpiry(pos.expiry_date)}</td>
                              <td style={{...s.td,color:T.buy,fontWeight:500}}>{fmtQty(pos.buy_qty)}</td>
                              <td style={{...s.td,color:T.sell,fontWeight:500}}>{fmtQty(pos.sell_qty)}</td>
                              <td style={s.td}><QtyDisplay v={pos.net_qty}/></td>
                              <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>)}
              </>
            }
          </div>
        )}

        {/* ── B/F TAB ── */}
        {activeTab==='bf' && (
          <div className="nb-fade">
            {bfLoading?<div style={s.emptyState}>Loading B/F positions…</div>
            :!bfData||(bfOptions.length===0&&bfFutures.length===0)?<div style={s.emptyState}>No B/F positions found.</div>
            :<>
                <div style={s.sumBar}>
                  {[{l:'Total open',v:bfData.total_open_qty??0,c:T.brand},{l:'Positions',v:bfData.total_positions??0,c:T.tx},{l:'Options',v:bfOptions.length,c:'#7c3aed'},{l:'Futures',v:bfFutures.length,c:T.ok}].map((item,i)=>(
                    <div key={i} style={s.sumItem}><div style={s.sumLbl}>{item.l}</div><div style={s.sumVal(item.c)}>{item.v}</div></div>
                  ))}
                  <div style={{...s.sumItem,marginLeft:'auto'}}><div style={s.vonly}>View only — no square-off</div></div>
                </div>
                {bfOptions.length>0&&(<>
                  <SectionHdr title="Options" count={bfOptions.length}/>
                  <div style={s.tcard}>
                    <div style={{overflowX:'auto'}}>
                      <table style={{width:'100%',borderCollapse:'collapse',minWidth:480}}>
                        <thead><tr>{['Symbol & strike','Expiry','Type','Net qty (lots)','Exchange'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                          {bfOptions.map(pos=>(
                            <tr key={pos.bf_id} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                              <td style={s.td}><div style={{fontWeight:600}}>{pos.symbol}</div>{pos.strike_price&&<div style={{fontSize:11,color:T.tx2}}>₹{formatStrike(pos.strike_price)}</div>}</td>
                              <td style={{...s.td,fontSize:12,color:T.tx2}}>{formatExpiry(pos.expiry_date)}</td>
                              <td style={s.td}><span style={s.typePill(pos.option_type)}>{pos.option_type}</span></td>
                              <td style={s.td}><QtyDisplay v={pos.qty_in_lots??pos.total_open_qty??(Number(pos.opng_lng_qty||0)-Number(pos.opng_shrt_qty||0))}/></td>
                              <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>)}
                {bfFutures.length>0&&(<>
                  <SectionHdr title="Futures" count={bfFutures.length}/>
                  <div style={s.tcard}>
                    <div style={{overflowX:'auto'}}>
                      <table style={{width:'100%',borderCollapse:'collapse',minWidth:400}}>
                        <thead><tr>{['Symbol','Expiry','Net qty (lots)','Exchange'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                          {bfFutures.map(pos=>(
                            <tr key={pos.bf_id} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                              <td style={{...s.td,fontWeight:600}}>{pos.symbol}</td>
                              <td style={{...s.td,fontSize:12,color:T.tx2}}>{formatExpiry(pos.expiry_date)}</td>
                              <td style={s.td}><QtyDisplay v={pos.qty_in_lots??pos.total_open_qty??(Number(pos.opng_lng_qty||0)-Number(pos.opng_shrt_qty||0))}/></td>
                              <td style={s.td}><ExchBadge exchange={pos.exchange} segment={pos.segment}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>)}
              </>
            }
          </div>
        )}

        {/* ── HOLDINGS TAB ── */}
        {activeTab==='holdings' && (
          <div className="nb-fade">
            {holdingsLoading?<div style={s.emptyState}>Loading holdings…</div>
            :!holdingsData||holdingsData.holdings?.length===0?<div style={s.emptyState}>{holdingsData?.message||'No holdings found.'}</div>
            :<>
                <div style={s.sumBar}>
                  {[{l:'Securities',v:holdingsData.total_holdings,c:T.brand},{l:'Quantity',v:holdingsData.total_quantity,c:T.tx},{l:'Total value',v:'₹'+Number(holdingsData.total_value).toLocaleString('en-IN',{maximumFractionDigits:0}),c:T.ok}].map((item,i)=>(
                    <div key={i} style={s.sumItem}><div style={s.sumLbl}>{item.l}</div><div style={s.sumVal(item.c)}>{item.v}</div></div>
                  ))}
                  <div style={{...s.sumItem,marginLeft:'auto'}}><div style={{...s.vonly,background:T.okBg,borderColor:T.ok,color:T.okTx}}>NSDL · as of {holdingsData.date}</div></div>
                </div>
                <div style={s.tcard}>
                  <div style={{overflowX:'auto'}}>
                    <table style={{width:'100%',borderCollapse:'collapse',minWidth:520}}>
                      <thead><tr>{['Company','Qty','Close price','Value','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                      <tbody>
                        {holdingsData.holdings.map(h=>(
                          <tr key={h.id} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                            <td style={{...s.td,fontWeight:600,fontSize:fs-1}}>{h.company_name}</td>
                            <td style={{...s.td,fontWeight:500}}>{h.quantity}</td>
                            <td style={{...s.td,color:T.tx2}}>₹{Number(h.close_price).toLocaleString('en-IN',{maximumFractionDigits:2})}</td>
                            <td style={{...s.td,color:T.ok,fontWeight:500}}>₹{Number(h.total_value).toLocaleString('en-IN',{maximumFractionDigits:0})}</td>
                            <td style={s.td}>
                              {placedHoldings[h.isin]
                                ?<span style={s.placedBdg}>Order placed</span>
                                :<button style={{...s.sqBtn(true)}} className="nb-btn" onClick={()=>handleHoldingSquareOff(h)}>Square off</button>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            }
          </div>
        )}

        {/* ── ORDERS TAB ── */}
        {activeTab==='orders' && (
          <div className="nb-fade">
            {(() => {
              // Use pre-computed clientVisibleOrders (same filter as tab count)
              const clientOrders = clientVisibleOrders;
              const fmtDateTime = (dt) => {
                if (!dt) return '—';
                const d = new Date(dt);
                const date = d.toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'});
                const time = d.toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:true});
                return `${date}, ${time}`;
              };
              const statusDisplay = (raw) => {
                const st = (raw||'').toUpperCase();
                // FILE_GENERATED is admin-only — show as Order received to client
                if (st==='ORDER_RECEIVED'||st==='RECEIVED'||st==='FILE_GENERATED')
                                                              return {label:'Order received',   col:'#1B4FD8', bg:'#EEF2FF'};
                if (st==='PARTIALLY_TRADED')                  return {label:'Partially traded', col:'#D97706', bg:'#FFFBEB'};
                if (st==='TRADED'||st==='ORDER_TRADED')       return {label:'Traded',           col:T.ok,     bg:T.okBg};
                if (st==='REJECTED')                          return {label:'Rejected',         col:T.err,    bg:T.errBg};
                return {label:'Order received', col:'#1B4FD8', bg:'#EEF2FF'};
              };
              if (clientOrders.length===0) return (
                <div style={s.emptyState}>No orders placed yet in this session.</div>
              );
              return (
                <div style={s.tcard}>
                  <div style={{overflowX:'auto'}}>
                    <table style={{width:'100%',borderCollapse:'collapse',minWidth:560}}>
                      <thead><tr>{['Symbol','Exchange','Type','Qty','Status','Date & time'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                      <tbody>
                        {clientOrders.map((ord,i)=>{
                          const st=statusDisplay(ord.status);
                          return(<tr key={ord.order_id||i} style={{borderBottom:`0.5px solid ${T.bdr}`}}>
                            <td style={{...s.td,fontWeight:600,maxWidth:200}}>
                              {ord.symbol}
                              {ord.strike_price && <span style={{fontSize:10,color:T.tx2,marginLeft:4}}>₹{ord.strike_price} {ord.option_type}</span>}
                              {ord.expiry_date && <span style={{fontSize:10,color:T.tx2,marginLeft:4}}>· {new Date(ord.expiry_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short'})}</span>}
                            </td>
                            <td style={s.td}><ExchBadge exchange={ord.exchange} segment={ord.segment}/></td>
                            <td style={{...s.td,color:ord.side==='SELL'?T.sell:T.buy,fontWeight:600}}>{ord.side}</td>
                            <td style={s.td}>{ord.quantity}</td>
                            <td style={s.td}>
                              <span style={{background:st.bg,color:st.col,border:`0.5px solid ${st.col}`,borderRadius:6,fontSize:10,fontWeight:600,padding:'3px 9px',whiteSpace:'nowrap'}}>
                                {st.label}
                              </span>
                            </td>
                            <td style={{...s.td,color:T.tx2,fontSize:11,whiteSpace:'nowrap'}}>{fmtDateTime(ord.placed_at||ord.created_at)}</td>
                          </tr>);
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        <footer style={s.footer}>
          Refreshes every 60 seconds &nbsp;·&nbsp;
          <a href="mailto:support@navia.co.in" style={s.footerLnk}>support@navia.co.in</a>
          &nbsp;·&nbsp;
          <a href="https://support.navia.co.in" target="_blank" rel="noreferrer" style={s.footerLnk}>support.navia.co.in</a>
          &nbsp;·&nbsp; Navia Markets Ltd · SEBI registered
        </footer>
      </main>
    </div>
  );
}